export enum Discount {
  Amount = 50,
  UnitMeasurement = '%',
}
